import React              from 'react';
import PropTypes          from 'prop-types';
import ImmutablePropTypes from 'immutable-prop-types';
import Label              from 'pu-react/components/Label';
import RadioComponent     from 'pu-react/components/RadioComponent';

const ArraySide = props => {
  const { parameters, name } = props
  const value = parameters[name];
  return (
    <RadioComponent
      name={props.name}
      label={props.label}
      value={props.value}
      checked={value === props.value}
      onChange={() => props.onChangeParameter(props.name, props.value)}
      inputId={props.inputId}
      groupName={props.groupName}
      parameters={props.parameters}/>
  )
};

ArraySide.defaultProps = {
  name     : 'rails_sides',
  // groupName: 'customer',
  groupName: 'parameters',
};

// ArraySide.propTypes = {
//   name             : PropTypes.string,
//   groupName        : PropTypes.string,
//   label            : PropTypes.string.isRequired,
//   value            : PropTypes.string.isRequired,
//   onChangeParameter: PropTypes.func.isRequired,
//   inputId          : PropTypes.string.isRequired,
//   parameters       : ImmutablePropTypes.map.isRequired,
// };

const ArrayRailsSides = props => (
  <div className="form-group radio-group">
    <Label label="Add rails to" />
    <ArraySide
      label="the two long sides"
      value="two_long_sides"
      onChangeParameter={props.onChangeParameter}
      inputId="array-side-long"
      groupName={props.groupName}
      parameters={props.parameters} />
    <ArraySide
      label="the two short sides"
      value="two_short_sides"
      onChangeParameter={props.onChangeParameter}
      inputId="array-side-short"
      groupName={props.groupName}
      parameters={props.parameters} />
    <ArraySide
      label="all four sides"
      value="all_four_sides"
      onChangeParameter={props.onChangeParameter}
      inputId="array-side-all"
      groupName={props.groupName}
      parameters={props.parameters} />
    <ArraySide
      label="no rails"
      value="no_sides"
      onChangeParameter={props.onChangeParameter}
      inputId="array-side-no"
      groupName={props.groupName}
      parameters={props.parameters} />
    <div className="error-place" />
  </div>
);

// ArrayRailsSides.propTypes = {
//   onChangeParameter: PropTypes.func.isRequired,
//   parameters       : ImmutablePropTypes.map.isRequired,
// };

export default ArrayRailsSides;
